import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Table } from 'react-bootstrap';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import i18next, { t } from 'i18next';
import { TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import ReactApexChart from 'react-apexcharts';

class ELEMENT_CONTRACT_EDP_PARTIDAS_TBL extends React.Component {
	constructor(props) {
			super(props);

			this.state = {
				items: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent?.items.length > 0 ? this.props.inputParam_ComponentContent.items : []) : [], 
			};
	}
	static propTypes = {
		inputParam_HideHeader: PropTypes.bool,
		inputParam_ComponentContent: PropTypes.object,
		inputParam_UseFake: PropTypes.bool,
		inputParam_BoardStructure: PropTypes.object,
		inputParam_Container: PropTypes.object,
	};

	static defaultProps = {
		inputParam_HideHeader: false,
		inputParam_ComponentContent: null,
		inputParam_BoardStructure: null,
		inputParam_Container: null,
		inputParam_UseFake: false
	};

	getSparkLineChart(l_vals) {
		var options = {
			chart: {
				type: 'line',
				width: "100px",
				height: "20px",
				sparkline: {
					enabled: true
				}
			},
			stroke: {
				width: 1,
				curve: 'smooth',
			},
			tooltip: {
				fixed: {
					enabled: false
				},
				x: {
					show: false
				},
				y: {
					title: {
						formatter: function (seriesName) {
							return ''
						}
					}
				},
				marker: {
					show: false
				},
				offsetY: -100,
				offsetX: 150,
			}
		};

		return <ReactApexChart height={"20px"} width={"100px"} options={options} series={[{data: l_vals}]}/>
	}

  	renderComponent() {
		return  <Row className='px-3 h-100' style={{overflow: 'scroll', opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
					<Col className='mx-auto p-0'>
						<Table className='w-100'>
							<thead>                                                
								<tr style={{ backgroundColor: '#0F437E', color: 'white', fontWeight: 'bold' }}>
									<td className='px-1 border-end'>{t('data-lang-lbl-item')}</td>
									<td className='px-1 border-end'>{t('data-lang-lbl-partie')}</td>
									<td className='px-1 border-end'>{t('data-lang-lbl-class')}</td>
									<td className='px-1 border-end'>{t('data-lang-lbl-contractbaseamount')}</td>
									<td className='px-1 border-end'>{t('data-lang-lbl-ep')}</td>
									<td className='px-1 border-end'>{t('data-lang-lbl-balance')}</td>
									<td className='px-1' style={{width: '120px'}}>{t('data-lang-lbl-tendence')}</td>
								</tr>
							</thead>
							<tbody>
							{
								this.state?.items && this.state?.items.length > 0 && this.state.items.map((x) => (
									<tr key={x.iD_PARTIDA} className='border-bottom mb-1'>
										<td className='px-1 text-start border-end'>{x.partidA_CODIGO}</td>
										<td className='px-1 text-start border-end' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
											<TooltipHost content={x.partidA_NOMBRE}>
												{`${x.partidA_NOMBRE} (${x.partidA_UM})`}
											</TooltipHost>
										</td>
										<td className='px-1 text-start border-end'>{x.partidA_CLASE_NEMO}</td>
										<td className='px-1 text-end   border-end'>{x.partidA_MONTO_BASE_MC !== null ? parseFloat(x.partidA_MONTO_BASE_MC.toFixed(2)).toLocaleString(i18next.language): '--'}</td>
										<td className='px-1 text-end   border-end'>{x.eP_MONTO_PAGO_MC !== null ? parseFloat(x.eP_MONTO_PAGO_MC.toFixed(2)).toLocaleString(i18next.language): '--'}</td>
										<td className='px-1 text-end   border-end'>{x.eP_MONTO_SALDO_MC !== null ? parseFloat(x.eP_MONTO_SALDO_MC.toFixed(2)).toLocaleString(i18next.language): '--'}</td>
										<td className='px-1 text-center'>{this.getSparkLineChart(x.l_MONTO_PAGO_MC)}</td>
									</tr>
								))
							}
							</tbody>
						</Table>
					</Col>
				</Row>
  	}

	render() {
			return (
				<>
					{
						!this.props.inputParam_UseFake &&
						<Card className='h-100 overflow-hidden'>
							<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
								<b>{ this.state !== null ? (this.state.boardComponentTitle ?? t('data-lang-boxname-itemtable')) : t('data-lang-boxname-itemtable')}</b>
								<div className='toolbar d-flex'>
									<HEADER_TOOLBAR
										inputParam_BoardStructure={this.props.inputParam_BoardStructure}
										inputParam_Container={this.props.inputParam_Container}
									/>
								</div>
						</Card.Body>
							<Card.Body className='px-1 py-0 h-100'>
								{this.renderComponent()}
							</Card.Body>
						</Card>
					}
					{this.props.inputParam_UseFake && this.renderComponent()}
				</>
			);
	}
}

export default ELEMENT_CONTRACT_EDP_PARTIDAS_TBL;